(() => {
  if (customElements.get('complementary-products')) {
    return;
  }

  class ComplementaryProducts extends customElements.get(
    'card-product-slider'
  ) {
    constructor() {
      super();

      const swiperOptions = JSON.parse(this.getAttribute('data-swiper-options')) || {};

      this.sliderOptions = {
        slidesPerView: swiperOptions.slidesPerViewMobile || 1,
        spaceBetween: swiperOptions.spaceBetweenMobile || 2,
        breakpoints: {
          990: {
            spaceBetween: swiperOptions.spaceBetweenDesktop || 2,
            slidesPerView: swiperOptions.slidesPerViewDesktop || 2,
            slidesPerGroup: 2
          }
        }
      };
    }

    initSlider() {
      super.initSlider();
      this.parentElement.classList.remove('hidden');

      // Reveal the entire section wrapper now that we have products
      var sectionWrapper = this.closest('[data-cts-section]');
      if (sectionWrapper) sectionWrapper.classList.remove('hidden');

      // Reveal compact wrapper if in compact mode
      var compactWrap = document.querySelector('.cts-compact-inline');
      if (compactWrap) compactWrap.style.display = '';

      if (document.querySelector("quick-cart-drawer")) {
        document.querySelector("quick-cart-drawer").init();
      }

      if (Shopify.designMode) {
        if (document.querySelector("quick-cart-drawer")) {
          document.querySelector("quick-cart-drawer").init();
        }
      }
    }
  }

  customElements.define(
    'complementary-products',
    ComplementaryProducts
  );
})();
